import React, { useCallback, useEffect, useReducer, useState } from "react";
import dynamic from "next/dynamic";
import Alert from "react-bootstrap/Alert";

import { product, requestData, pageUrl } from "@utils/product";
import { api } from "@utils/api";
import { useApp } from "@context/AppProvider";
import Loading from "@components/Loading";
import Item from "@components/product/list/Item";
import { reducer } from "@reducers/wishlist/list";
import { useCart } from "@context/CartProvider";
const CommonBreadcrumbs = dynamic(() =>
  import("@components/common/CommonBreadcrumbs")
);

const ProductDetailModal = dynamic(() => import("@models/ProductDetail.modal"));
const Pagination = dynamic(() => import("./Pagination"));
//const Breadcrumbs = dynamic(() => import('./Breadcrumbs'));
const UpBlock = dynamic(() => import("./UpBlock"));

const breadcrumbs = [{ name: "Wishlist", href: "" }];

import { WishlistProvider } from "./Context/Wishlist";

const initState = {
  productsData: [],
  pageInfo: {
    limit: 21,
    page: 1,
    pages: 1,
    total: 0,
    skip: 0,
  },
  btFee: 0,
  goodCausePer: 0,
  stripeFee: 0,
  loading: true,
};

const NoItem = () => {
  return (
    <div className="row">
      <div className="col-md-12 text-center">
        <Alert variant="danger" className=" p-5 wishlistDanger">
          <Alert.Heading style={{ color: "#fff" }}>
            No items saved!
          </Alert.Heading>
        </Alert>
      </div>
    </div>
  );
};

function Listing(props) {
  const { styles, filters } = props;
  const [state, dispatch] = useReducer(reducer, initState);
  const [isWishlistRemoved, setisWishlistRemoved] = useState(null);
  const {
    idb: { isoCode, session, user },
  } = useApp();
  const { fetchWishlistCount } = useCart();
  const loadData = useCallback(async () => {
    dispatch({
      type: "SET_DATA",
      data: {
        ...initState,
        productsData: [],
        loading: true,
      },
    });
    const res = await api(
      {
        url: "/wishlist",
        method: "POST",
        data: { ...requestData(props) },
      },
      session
    );
    let resData = {};
    fetchWishlistCount();
    if (res.status && res.resData.products_data) {
      resData = {
        productsData: res.resData.products_data,
        pageInfo: {
          limit: res.resData.limit,
          page: res.resData.page,
          pages: res.resData.pages,
          total: res.resData.total,
          skip: res.resData.skip,
        },
        btFee: res.resData.default_bt_fee,
        goodCausePer: res.resData.good_cause_percentage,
        stripeFee:
          isoCode.toLowerCase() === "au"
            ? res.resData.australia_stripe_fee
            : res.resData.international_stripe_fee,
        loading: false,
      };
    }
    dispatch({
      type: "SET_DATA",
      data: {
        ...resData,
        loading: false,
      },
    });
  }, [props, session, fetchWishlistCount, isoCode]);

  useEffect(() => {
    if (session) {
      loadData();
    }
  }, [loadData, session, user]);
  const callBackMethodModal = () => {
    dispatch({
      type: "SET_DATA",
      data: {
        showProductModal: false,
        modalData: {},
      },
    });
    if (isWishlistRemoved) {
      loadData();
      setisWishlistRemoved(null);
    }
  };
  const removeAllWishlist = async () => {
    dispatch({
      type: "SET_DATA",
      data: {
        loading: true,
      },
    });
    await api(
      {
        url: "/wishlist/delete",
        method: "GET",
        params: {},
      },
      session
    );
    loadData();
  };
  const removeFromWishlist = useCallback(
    async (data) => {
      try {
        dispatch({
          type: "SET_DATA",
          data: {
            loading: true,
          },
        });
        const result = await api(
          {
            url: `/wishlist/upsert`,
            method: "POST",
            data: {
              // eslint-disable-next-line camelcase
              product_id: data._id,
            },
          },
          session
        );
        if (result.status) {
          loadData();
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    [dispatch, session, loadData]
  );
  console.log(state.productsData, "fff");
  return (
    <WishlistProvider props={props}>
      <div className={styles.heading}>
        <h1 className={styles.wishlist_heading}>Shopping wishlist</h1>
      </div>
      <div className="container">
        <CommonBreadcrumbs breadcrumbs={breadcrumbs}></CommonBreadcrumbs>
        {/* <Breadcrumbs {...props} /> */}
        <div className="row listing-row">
          <div className={`col-md-12 ${styles.listingColRight}`}>
            <div className={styles.listingRightBlock}>
              <UpBlock
                loading={state.loading}
                total={state.pageInfo.total}
                styles={styles}
                filters={filters}
                pageUrl={pageUrl(props)}
                store={props.store}
                pageUrlFn={pageUrl}
              />
              {state.loading ? (
                <Loading.ProductList length={21} />
              ) : state.productsData.length ? (
                <>
                  <div className="d-flex justify-content-end mb-2">
                    <button
                      onClick={removeAllWishlist}
                      className={`${styles.btnCustom} ${styles.btn_type1} px-3 w-auto overcastBtn`}
                    >
                      {" "}
                      Remove All{" "}
                    </button>
                  </div>
                  <div className={`row ${styles.wishlistOuter}`}>
                    {state.productsData.map((p, key) => {
                      const data = product(p, state.currencyData, props);
                      let btFee = state.btFee;
                      if (p.retailer.length === 1) {
                        const r = p.retailer[0];

                        if (r && r.transactionChargePercentage) {
                          btFee = +r.transactionChargePercentage;
                        }
                      }
                      data["wishlistData"] = { _id: p.wishlist_id };
                      return (
                        <Item
                          data={data}
                          key={key}
                          removeFromWishlist={removeFromWishlist}
                          styles={styles}
                          state={state}
                          btFee={btFee}
                          dispatch={dispatch}
                          retailerCount={p.retailer?.length}
                          isWishlist={true}
                          //store={true}
                        />
                      );
                    })}
                  </div>
                  {state?.pageInfo?.pages > 1 && (
                    <Pagination
                      {...state.pageInfo}
                      filters={filters}
                      pageUrl={pageUrl(props)}
                    />
                  )}
                </>
              ) : (
                <NoItem {...props} />
              )}
              {state.showProductModal && (
                <ProductDetailModal
                  product={state.modalData.product}
                  brand={state.modalData.brand}
                  currencyData={state.modalData.currencyData}
                  mas={state.modalData.mas}
                  promotions={state.modalData.promotions}
                  settings={state.modalData.settings}
                  queryParams={state.modalData.queryParams}
                  isBrand={state.modalData.isBrand}
                  removeWishlist={setisWishlistRemoved}
                  close={callBackMethodModal}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </WishlistProvider>
  );
}

export default Listing;
